import { apiClient } from './client';
import type { ConversationDetail } from '@/components/chat/types';

export interface InboxConversation {
  id: string;
  status: string;
  source: string;
  title: string | null;
  visitorName: string | null;
  visitorEmail: string | null;
  assignedAgentName: string | null;
  lastMessageAt: string;
  createdAt: string;
  preview: string | null;
}

export const chatApi = {
  listInbox: () =>
    apiClient.get<InboxConversation[]>('/api/chat/inbox'),

  getConversation: (id: string) =>
    apiClient.get<ConversationDetail>(`/api/chat/conversations/${id}`),

  takeOver: (id: string) =>
    apiClient.post<void>(`/api/chat/conversations/${id}/take-over`),

  sendAgentMessage: (id: string, content: string) =>
    apiClient.post<void>(`/api/chat/conversations/${id}/agent-message`, { content }),

  resolve: (id: string) =>
    apiClient.post<void>(`/api/chat/conversations/${id}/resolve`),
};
